/* Sneakclean — application.js */

document.addEventListener('DOMContentLoaded', () => {

  /* ==================== Mobile drawer ==================== */
  const drawer = document.querySelector('.mobile-drawer');
  const drawerBackdrop = document.querySelector('.mobile-drawer__backdrop');
  const drawerTrigger = document.querySelector('[data-open-drawer]');
  let drawerReturnFocus = null;

  function openMobileDrawer(trigger) {
    if (!drawer) return;
    drawerReturnFocus = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawerTrigger?.setAttribute('aria-expanded', 'true');
    if (drawerBackdrop) {
      drawerBackdrop.hidden = false;
      requestAnimationFrame(() => drawerBackdrop.classList.add('is-open'));
    }
    document.documentElement.classList.add('is-locked');
    drawer.focus({ preventScroll: true });
  }

  function closeMobileDrawer({ restoreFocus = true } = {}) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawerTrigger?.setAttribute('aria-expanded', 'false');
    drawerBackdrop?.classList.remove('is-open');
    window.setTimeout(() => { if (drawerBackdrop) drawerBackdrop.hidden = true; }, 220);
    document.documentElement.classList.remove('is-locked');
    if (restoreFocus && drawerReturnFocus instanceof HTMLElement) drawerReturnFocus.focus({ preventScroll: true });
  }

  document.querySelectorAll('[data-open-drawer]').forEach(button => {
    button.addEventListener('click', () => openMobileDrawer(button));
  });
  document.querySelectorAll('[data-close-drawer]').forEach(button => {
    button.addEventListener('click', () => closeMobileDrawer());
  });
  drawer?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => closeMobileDrawer({ restoreFocus: false })));
  drawer?.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), summary, input, select, textarea')]
      .filter(el => !el.hasAttribute('hidden') && el.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  /* El carrito Web 2.0 vive en cart-controller.js. application.js conserva
     navegación, búsqueda y quick view, pero nunca muta el carrito por su cuenta. */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeMobileDrawer();
      closeSearch();
    }
  });

  /* ==================== Marquee duplicate for seamless loop ==================== */
  document.querySelectorAll('.marquee__track').forEach(track => {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  /* ==================== Video poster ==================== */
  document.querySelectorAll('[data-video-poster]').forEach(poster => {
    poster.addEventListener('click', () => {
      const block = poster.closest('.video-block');
      const url = poster.dataset.videoPoster;
      if (!block || !url) return;
      let embed = url;
      if (url.includes('youtube.com/watch?v=')) {
        const id = new URL(url).searchParams.get('v');
        embed = `https://www.youtube.com/embed/${id}`;
      } else if (url.includes('youtu.be/')) {
        const id = url.split('youtu.be/')[1].split(/[?&#]/)[0];
        embed = `https://www.youtube.com/embed/${id}`;
      } else if (url.includes('vimeo.com/')) {
        const id = url.split('vimeo.com/')[1].split(/[?&#]/)[0];
        embed = `https://player.vimeo.com/video/${id}`;
      }
      block.innerHTML = `<iframe src="${embed}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>`;
    });
  });

  /* ==================== Mega-menu hover with delay (no flicker on cursor move) ==================== */
  const HOVER_DELAY = 250;
  document.querySelectorAll('[data-has-mega]').forEach(el => {
    let timer;
    const trigger = el.querySelector('.site-nav__top');
    const open = () => {
      clearTimeout(timer);
      el.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      timer = setTimeout(() => {
        el.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');
      }, HOVER_DELAY);
    };
    el.addEventListener('mouseenter', open);
    el.addEventListener('mouseleave', close);
    el.addEventListener('focusin', open);
    el.addEventListener('focusout', event => {
      if (!el.contains(event.relatedTarget)) close();
    });
    el.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      clearTimeout(timer);
      el.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus();
    });
  });

  /* ==================== Quick view modal (variants without leaving page) ==================== */
  const qvModal = document.querySelector('[data-quick-view-modal]');
  const qvContent = qvModal?.querySelector('[data-quick-view-content]');

  function openQv() {
    qvModal?.classList.add('is-open');
    document.documentElement.classList.add('is-locked');
  }
  function closeQv() {
    qvModal?.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
  }
  document.querySelectorAll('[data-close-quick-view]').forEach(b => b.addEventListener('click', closeQv));

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.productHandle;
    const mode = btn.dataset.quickViewMode || 'cart';
    if (!handle || !qvContent) return;
    qvContent.innerHTML = '<p class="quick-view__loading">Cargando producto...</p>';
    openQv();
    try {
      const product = await fetch('/products/' + handle + '.js').then(r => r.json());
      qvContent.innerHTML = renderQuickView(product);
      initQuickView(qvContent, product, mode);
    } catch (err) {
      qvContent.innerHTML = '<p class="quick-view__loading">No pudimos cargar el producto. <a href="/products/' + handle + '">Ver detalles →</a></p>';
    }
  });

  function renderQuickView(p) {
    const img = p.featured_image || (p.images && p.images[0]) || '';
    const compare = p.compare_at_price;
    const hasOptions = p.options && !(p.options.length === 1 && p.options[0] === 'Title');
    return `
      <div class="quick-view__grid">
        <div class="quick-view__media">
          ${img ? `<img src="${img}" alt="${escapeHtml(p.title)}">` : ''}
        </div>
        <div class="quick-view__info">
          ${p.vendor ? `<small class="quick-view__vendor">${escapeHtml(p.vendor)}</small>` : ''}
          <h2 class="quick-view__title">${escapeHtml(p.title)}</h2>
          <div class="quick-view__price" data-qv-price>
            ${compare && compare > p.price ? `<del>${formatPrice(compare)}</del> ` : ''}
            <span data-qv-price-amount>${formatPrice(p.price)}</span>
          </div>
          ${hasOptions ? p.options.map((opt, i) => {
            const values = [...new Set(p.variants.map(v => v.options[i]))];
            return `
              <div class="quick-view__option">
                <span class="pdp__variant-label">${escapeHtml(opt)}</span>
                <div class="pdp__swatches" data-qv-option="${i}">
                  ${values.map(val => `
                    <label class="pdp__swatch">
                      <input type="radio" name="qv_option_${i}" value="${escapeHtml(val)}" style="display:none">
                      ${escapeHtml(val)}
                    </label>
                  `).join('')}
                </div>
              </div>
            `;
          }).join('') : ''}
          <button type="button" class="btn btn--accent btn--block quick-view__add" data-qv-add>Agregar al carrito</button>
          <a href="/products/${p.handle}" class="quick-view__details">Ver detalles completos →</a>
        </div>
      </div>
    `;
  }

  function initQuickView(container, product, mode) {
    function getSelectedVariant() {
      const selected = product.options.map((opt, i) => {
        const wrap = container.querySelector(`[data-qv-option="${i}"]`);
        return wrap?.querySelector('input:checked')?.value;
      });
      if (selected.includes(undefined)) return null;
      return product.variants.find(v => v.options.every((o, i) => o === selected[i]));
    }
    function updatePriceAndAvailability() {
      const v = getSelectedVariant();
      const priceAmount = container.querySelector('[data-qv-price-amount]');
      const priceWrap = container.querySelector('[data-qv-price]');
      const addBtn = container.querySelector('[data-qv-add]');
      if (!v) return;
      if (priceAmount) priceAmount.textContent = formatPrice(v.price);
      if (priceWrap) {
        const del = priceWrap.querySelector('del');
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (del) del.textContent = formatPrice(v.compare_at_price);
          else priceWrap.insertAdjacentHTML('afterbegin', `<del>${formatPrice(v.compare_at_price)}</del> `);
        } else if (del) del.remove();
      }
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.textContent = mode === 'buy' ? 'Comprar ya' : 'Agregar al carrito';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Agotado';
        }
      }
    }

    container.querySelectorAll('.pdp__swatch').forEach(label => {
      label.addEventListener('click', () => {
        const wrap = label.closest('[data-qv-option]');
        wrap.querySelectorAll('.pdp__swatch').forEach(l => l.classList.remove('is-active'));
        label.classList.add('is-active');
        const input = label.querySelector('input');
        if (input) input.checked = true;
        updatePriceAndAvailability();
      });
    });

    // Pre-select first available variant's options
    const firstAvailable = product.variants.find(v => v.available) || product.variants[0];
    if (firstAvailable) {
      product.options.forEach((opt, i) => {
        const wrap = container.querySelector(`[data-qv-option="${i}"]`);
        if (!wrap) return;
        const target = wrap.querySelector(`input[value="${CSS.escape(firstAvailable.options[i])}"]`);
        if (target) {
          target.checked = true;
          target.closest('label').classList.add('is-active');
        }
      });
      updatePriceAndAvailability();
    }

    container.querySelector('[data-qv-add]')?.addEventListener('click', async (e) => {
      const v = getSelectedVariant();
      if (!v) { alert('Selecciona todas las opciones.'); return; }
      if (!v.available) return;
      const btn = e.currentTarget;
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Agregando...';
      try {
        if (mode === 'buy') {
          // Add and redirect to checkout
          const root = window.SC_CONFIG?.rootUrl || '/';
          const checkout = window.SC_CONFIG?.checkoutUrl || `${root}checkout`;
          const cart = window.SneakCleanCartController;
          // Con preventa activa se agrega por el carrito para que entren las Pills de regalo.
          if (window.SC_CONFIG?.preventa && cart?.ensurePreventa) {
            await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: v.id, quantity: 1 }) });
            await cart.ensurePreventa();
            window.location.href = checkout;
            return;
          }
          window.location.href = `${root}cart/add?id=${encodeURIComponent(v.id)}&quantity=1&return_to=${encodeURIComponent(checkout)}`;
          return;
        }
        const fd = new FormData();
        fd.append('id', v.id);
        fd.append('quantity', '1');
        const root = window.SC_CONFIG?.rootUrl || '/';
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: fd
        });
        if (!res.ok) throw new Error('add failed');
        const item = await res.json().catch(() => ({}));
        closeQv();
        document.dispatchEvent(new CustomEvent('sneakclean:cart-added', {
          bubbles: true,
          detail: { item, source: 'quick-view' }
        }));
      } catch (err) {
        alert('No pudimos agregar el producto.');
        btn.textContent = original;
        btn.disabled = false;
      }
    });
  }

  function formatPrice(cents) {
    // Shopify returns price in cents (CLP has 0 decimals). Use Intl for nice format.
    try {
      const n = (typeof cents === 'string') ? parseInt(cents, 10) : cents;
      const value = (n / 100).toFixed(0);
      return '$' + Number(value).toLocaleString('es-CL');
    } catch(e) { return '$' + cents; }
  }
  /* ==================== Search overlay (live) ==================== */
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchInput = searchOverlay?.querySelector('[data-search-input]');
  const searchResults = searchOverlay?.querySelector('[data-search-results]');
  const searchEmpty = searchOverlay?.querySelector('[data-search-empty]');

  function openSearch() {
    searchOverlay?.classList.add('is-open');
    document.documentElement.classList.add('is-locked');
    setTimeout(() => searchInput?.focus(), 50);
  }
  function closeSearch() {
    searchOverlay?.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
  }
  document.querySelectorAll('[data-open-search]').forEach(b => b.addEventListener('click', openSearch));
  document.querySelectorAll('[data-close-search]').forEach(b => b.addEventListener('click', closeSearch));

  let searchTimer;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (!q) {
      if (searchEmpty) searchEmpty.style.display = '';
      const old = searchResults?.querySelector('[data-search-list]');
      if (old) old.remove();
      return;
    }
    searchTimer = setTimeout(() => doSearch(q), 200);
  });

  async function doSearch(q) {
    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`);
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      renderSearch(q, products);
    } catch (err) {
      console.warn('search err', err);
      renderSearch(q, []);
    }
  }

  function renderSearch(q, products) {
    if (searchEmpty) searchEmpty.style.display = 'none';
    let list = searchResults?.querySelector('[data-search-list]');
    if (!list) {
      list = document.createElement('div');
      list.dataset.searchList = '';
      searchResults.appendChild(list);
    }
    if (products.length === 0) {
      list.innerHTML = `<p class="search-overlay__empty">Sin resultados para "${escapeHtml(q)}". <a href="/search?q=${encodeURIComponent(q)}">Buscar de todas formas →</a></p>`;
      return;
    }
    list.innerHTML = `
      <small class="cap-marker">Productos · ${products.length}</small>
      <div class="search-overlay__products">
        ${products.map(p => `
          <a href="${p.url}" class="search-overlay__product">
            ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">` : `<div style="background:var(--color-hairline);"></div>`}
            <div>
              ${p.vendor ? `<small class="cap-marker">${escapeHtml(p.vendor)}</small>` : ''}
              <h4>${escapeHtml(p.title)}</h4>
              <span>${p.price}</span>
            </div>
          </a>
        `).join('')}
      </div>
      <a href="/search?q=${encodeURIComponent(q)}" class="search-overlay__see-all">Ver todos los resultados →</a>
    `;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]);
  }
});
